import styles from "../Dashboard.module.css"
import { getStatusColor } from "../../../../utils/outorga/dashboard"
import { Badge } from "reactstrap"
import { grantStatus } from "../../../../utils/Enums/grantStatus"

const MarkerTooltip = ({ location, onClick }) => {
  return (
    <div
      className={styles.tooltipCard}
      style={{ borderLeftColor: getStatusColor(location.status) }}
      onClick={onClick}
    >
      <div className={styles.tooltipHeader}>
        {location.title}
      </div>

      <div className={styles.tooltipBody}>
        {location.info?.map((item, index) => (
          <div key={index} className={styles.tooltipRow} title={item.condicaoNome}>
            <span className={styles.tooltipLabel}>
              {item.label}:
            </span>

            <span className={styles.tooltipValue} style={{ color: item.color }}>
              {typeof item.value === "boolean" ? (
                <Badge color={item.value ? "success" : "secondary"}>
                  {item.condicaoNome}
                </Badge>
              ) : (
                item.value
              )}
            </span>
          </div>
        ))}
      </div>

      {location.status && (
        <div className={styles.tooltipStatus} style={{ color: getStatusColor(location.status) }}>
          {grantStatus[location.status]}
        </div>
      )}
    </div>
  )
}

export default MarkerTooltip